import * as action from './actions/creators';
import * as api from './api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

export const loadPatientNotifyPreference = (patientId) =>
  (dispatch) => api.getPatientFollowUpPlanNotifSettings(patientId)
    .then(
      (response) => {
        dispatch(action.patientNotifyPreferenceLoaded(response.data.patientSettings));
      },
      (err) => Promise.reject(err)
    );

export const loadFollowUpPlan = (patientId, showArchived) => (dispatch) =>
  api.getFollowUpPlans(patientId, showArchived).then(
    (response) => {
      dispatch(action.plansLoaded(
        response.data && response.data.length > 0 ? response.data[0] : {}
      ));
    },
    (axiosResponse) => {
      const error = axiosResponse.response;
      dispatch(MsgBarActions.showErrorMessage());
      dispatch(action.plansLoadFailed(error.message));
    }
  );
